<template>
    <div class="ellipsis-menu" ref="ellipsisMenuRoot">
        <button
            class="ellipsis-menu__button"
            @click="togglePopup"
            :aria-label="$ml.get('ellipsisAriaLabel')"
            :aria-expanded="show.toString()"
            aria-haspopup="true"
            tabindex="0"
            @keydown.enter.space="togglePopup"
        >
            <img
                src="@/assets/img/icons/ellipsis-vertical.svg"
                :alt="$ml.get('ellipsisAriaLabel')"
            />
        </button>

        <div
            v-if="show"
            class="ellipsis-menu__menu"
            role="menu"
            @keydown.esc="closePopup"
        >
            <slot />
        </div>
    </div>
</template>

<script>
    export default {

        data() {
            return {
                show: false
            };
        },

        computed: {},

        watch: {
            show(val) {
                if (val) {
                    this.$nextTick(() => {
                        if (this.$refs.firstOption) {
                            this.$refs.firstOption.focus();
                        }
                    });
                }
            }
        },

        mounted() {
            document.addEventListener('mousedown', this.handleClickOutside);
            document.addEventListener('keydown', this.handleEscKey);
        },

        beforeDestroy() {
            document.removeEventListener('mousedown', this.handleClickOutside);
            document.removeEventListener('keydown', this.handleEscKey);
        },

        methods: {

            togglePopup() {
                this.show = !this.show;
            },

            closePopup() {
                this.show = false;
            },

            handleClickOutside(event) {
                if (!this.$refs.ellipsisMenuRoot) return;
                if (!this.$refs.ellipsisMenuRoot.contains(event.target)) {
                    this.closePopup();
                }
            },

            handleEscKey(event) {
                if (event.key === 'Escape' && this.show) {
                    this.closePopup();
                }
            },

        }
    };
</script>

<style lang="scss" scoped>
    .ellipsis-menu {
        display: inline-block;
        position: relative;
        z-index: 1;

        &__button {
            padding: 8px;
            width: 36px;
            height: 36px;
            border: none;
            background: #fff;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        &__menu {
            position: absolute;
            top: 110%;
            right: 0;
            min-width: 161px;
            background: #fff;
            border-radius: 12px;
            box-shadow: 0 2px 8px rgba(26, 30, 35, 0.16);
            z-index: 10;
            display: flex;
            flex-direction: column;
            padding: 4px 0;

            > button{
                background: none;
                border: none;
                text-align: left;
                padding: 12px 16px;
                font-size: 1rem;
                font-weight: 500;
                color: #5C6A7B;
                cursor: pointer;
                transition: background 0.2s;

                &:hover {
                    background: #eff1f3;
                }

                &.remove {
                    color: #e53935;
                }
            }
        }
    }
</style>